import { Component, inject, OnInit } from '@angular/core';
import { ClientService } from '../../../core/services/client/client.service';
import { FormArray, FormControl, FormGroup, FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CurrencyVm } from '../../../core/models/currency-vm';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { Router, RouterOutlet } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DialogModule } from '@angular/cdk/dialog';
import { DialogComponent } from '../../../shared/components/dialogbox/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ResponseVm } from '../../../core/models/response-vm';
import { CountryVm } from '../../../core/models/country-vm';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatLabel } from '@angular/material/form-field';
import { LoginHeaderComponent } from '../../../shared/components/login-header/login-header.component';
import { FooterComponent } from '../../../shared/components/app-footer/footer.component';
import { LoadingService } from '../../../core/services/shared-services/loading.service';


@Component({
  selector: 'app-create-registration',
  standalone: true,
  imports: [RouterOutlet, MatButtonModule, MatInputModule,
    MatFormFieldModule, ReactiveFormsModule, FormsModule,
    MatListModule, MatIconModule, MatProgressSpinner, CommonModule, DialogModule, MatFormFieldModule,
    MatSelectModule, LoginHeaderComponent, FooterComponent,
    MatInputModule,
    ReactiveFormsModule, MatLabel],
  templateUrl: './create-registration.component.html',
  styleUrls: ['./create-registration.component.scss']
})

export class CreateRegistrationComponent implements OnInit {

  iClientRepository = inject(ClientService);
  private loader = inject(LoadingService);
  loading$ = this.loader.loading$;

  dialog = inject(MatDialog);
  registrationForm: FormGroup;
  currencies: CurrencyVm[] = [];
  countries: CountryVm[] = [];
  templateDetails: any[] = [];
  countryloaded = false;
  courencyloaded = false;
  constructor(private fb: FormBuilder, private router: Router) {
    this.registrationForm = this.fb.group({});
  }

  ngOnInit(): void {
    this.loadRegistrationTemplates();
    this.loadCountryList();
   // this.loadCurrencyList();
  }

  loadRegistrationTemplates() {
    this.iClientRepository.loadRegistrationTemplates().subscribe({
      next: data => {
        this.templateDetails = data[0].clientTemplateDetails; // Store template details
        this.createFormControls(this.templateDetails); // Populate the form with the first template
        console.log(data);
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });
  }

  loadCurrencyList() {
    if (this.courencyloaded)
      return;
    this.iClientRepository.getCurrencyList().subscribe({
      next: data => {
        this.currencies = data;
        this.courencyloaded = true;
        console.log(data);
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });
  }

  loadCountryList() {
    if (this.countryloaded)
      return;
    this.iClientRepository.getCountryList().subscribe({
      next: data => {
        this.countries = data;
        this.countryloaded = true;
        console.log(data);
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });
  }


  createFormControls(templateDetails: any[]) {
    // Sort templateDetails by sortOrder
    templateDetails.sort((a, b) => a.sortOrder - b.sortOrder);
    templateDetails.forEach(detail => {
      const validators = [];
      if (detail.mandatory) {
        validators.push(Validators.required);
      }
      const control = new FormControl('', validators);
      this.registrationForm.addControl(detail.columnName, control);

      /*    if (detail.columnName === 'redemptionCountry') {
         this.loadCountryList();
       } else if (detail.columnName === 'paymentCurrency') {
         this.loadCurrencyList();
       }   */
    });
  }

  getDropdownOptions(columnName: string): any[] {
    if (columnName === 'RedemptionCountry') {
      console.log('country', this.countries);
      return (this.countries || []).map(country => ({ value: country.bocmCountryId, label: country.bocmCountryName }));
    } else if (columnName === 'PaymentCurrency') {
      console.log('currencies', this.currencies);
      return (this.currencies || []).map(currency => ({ value: currency.bocmCurrencyID, label: currency.currencyCode }));
    }
    return [];
  }

  onSubmit() {
    if (this.registrationForm.valid) {

      const formData = this.registrationForm.value;
      const formattedData = {
        Objects: [formData]
      };

      this.iClientRepository.saveClient(formattedData).subscribe({
        next: (response: ResponseVm) => {
          if (response.responseCode === "1000") {
             this.router.navigate(["/thank-you"])
            // const dialogRef = this.dialog.open(DialogComponent, {
            //   minWidth: '300px',
            //   data: {
            //     message: response.responseMessage,
            //   },
            // });

            // dialogRef.afterClosed().subscribe(() => {
            //  this.router.navigate(["/thank-you"])
            // });

             //  this.registrationForm.reset("") // Reset the form after successful submission
          } else {
            this.dialog.open(DialogComponent, {
              minWidth: '300px',
              data: {
                message: response.responseMessage,
              },
            });
          }
        },
        error: (err) => {
          if (err.error.ResponseMessage) {
            this.dialog.open(DialogComponent, {
              minWidth: '300px',
              data: {
                message: err.error.ResponseMessage,
              },
            });
          }


        }
      });
    } else {
      this.displayValidationErrors();
      console.error('Form is invalid');
    }
  }

  displayValidationErrors() {
    Object.keys(this.registrationForm.controls).forEach(key => {
      const controlErrors = this.registrationForm.get(key)?.errors || null;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(errorKey => {
          this.dialog.open(DialogComponent, {
            minWidth: '300px',
            data: {
              message: `Validation error in ${key}: ${errorKey}`
            },
          });
          console.error(`Validation error in ${key}: ${errorKey}`);
        });
      }
    });
  }

  isDropdown(columnName: string): boolean {
    const dropdownFields = ['redemptionCountry', 'paymentCurrency']; // Example fields
    return dropdownFields.includes(columnName);
  }

  formControlKeys(): string[] {
    return Object.keys(this.registrationForm.controls);
  }
}
